module.exports = __webpack_public_path__ + "img/photo_size_select_large.c1cc6d2e.svg";